// import querystring from 'querystring'
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout(ctx) {
    if (ctx.route.query.token) return 'header-only';
    return 'empty';
  },
  data() {
    return {
      error: null,
      loaded: false,
      hasToken: false,
      hasLockedUser: false
    };
  },
  head() {
    return {
      title: 'Switch Your Bank'
    };
  },
  async mounted() {
    const {
      token
    } = this.$route.query;
    this.hasToken = !!token;
    if (!token) {
      this.loaded = true;
      return;
    }
    try {
      await this.$axios.$post('https://api.extra.app/v1/self-serve/switch-bank', {
        token
      });
      this.hasLockedUser = true;
    } catch (error) {
      this.error = error;
      console.error(error);
    }
    this.loaded = true;
  }
};